'use strict';
import * as _ from 'lodash';

export class ClipBoardNoteDetailDialogModel {
  constructor(data, title, patient, localStorage, isOffline) {

    this.isOffline = isOffline;
    this.resultData = data;
    this.data = _.cloneDeep(data);
    this.dataCopy = _.cloneDeep(data);

    this.title = title.toUpperCase();

    this.modalService = null;
    this.scope = null;    

    this.Patient = patient;
    this.LocalStorage = localStorage;
  }

  init(modal, scope, modalService) {    
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
  }
  
  _hasChanged() {
    return !_.isEqual(this.dataCopy, this.data);
  }

  async save() { 
    if (this.loading) {
      return;
    }

    if (!this.data.Clip) {
      this.modalService.showAlert("Note is required.");
      return;
    }

    const isOffline = await this.isOffline();
    if(isOffline) {
      return;
    }

    try {
      if(this._hasChanged()) {
        if (this.data.Id) {
          await this.update();
        } else {
          await this.create();
        }
      }
      _.assign(this.resultData, this.data);
      this.modalInstance.remove();       
    } catch (error) {   
      this.loading = false;      
      await this.modalService.showErrorMessage(error.data);
    }  
  }

  async create() {
    this.loading = true;

    this.data.Type = this.data.ClipboardOnly ? 'C' : 'N' ;

    const resp = await this.Patient.createPatClipNote(this.data);
    
    this.data.Id = resp.data;

    this.loading = false; 
  }

  async update() {
    this.loading = true;

    this.data.Type = this.data.ClipboardOnly ? 'C' : 'N' ;
    this.data.MUser = this.LocalStorage.get('UserLogin');
    await this.Patient.updatePatClipNote(this.data);
    
    this.loading = false;
  }

  async closeWindow() {
    if (this._hasChanged()) {
      const confirmed = await this.modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?');
      if (confirmed) {
        this.modalInstance.remove();
      }
      return;
    }
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/clipboardNoteDetail.js